import Head from 'next/head';
import React from 'react';
import { ArticlesList } from '../components';
import { withLayout } from '../Layout/Layout';

function TopLists() {
  return (
    <>
      <Head>
        <link rel="canonical" href={`${process.env.apiUrl}/trains`} />
        <meta
          name="description"
          content={
            'Discover the luxury of train travel with First-Class.com. Explore premium train journeys, services, and routes for your next adventure'
          }
        />
        <title>Trains: Premium Train Travel Experiences</title>
      </Head>
      <ArticlesList type="Trains" heading="Trains" />
    </>
  );
}

export default withLayout(TopLists, true);
